import { LazyLoadImage } from 'react-lazy-load-image-component';

import { wbAssetImageUrl } from '../../lib/wb-asset';

export const WbAssetImage = ({
  children,
  publicId,
  className,
  draggable,
  style,
  alt,
  imageType,
  transformation = {},
}) => {
  return (
    <LazyLoadImage
      src={wbAssetImageUrl({ publicId, imageType, transformation })}
      className={className}
      draggable={draggable}
      style={style}
      alt={alt}
      type={imageType}
    >
      {children}
    </LazyLoadImage>
  );
};
